import { ChangeDetectorRef, Component, inject, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@program-suite/util-icons';
import { ButtonComponent } from '../button/button.component';
import { DashboardService, ProgramTile } from '@program-suite/data-common';
import { AuthStore } from '@program-suite/data-auth';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-program-tiles',
  imports: [CommonModule, ButtonComponent],
  templateUrl: './program-tiles.component.html',
  styleUrl: './program-tiles.component.scss',
})
export class ProgramTilesComponent {
  authStore = inject(AuthStore);
  programTiles = signal<any[]>([]);
  icon = input<string>('');
  title = input<string | null>(null);

  onTileSelect = output<ProgramTile>();

  constructor(
    private router: Router,
    private dashaboardService: DashboardService,
    private cdr: ChangeDetectorRef,
  ) {
    this.loadProgramTiles();
  }

  async loadProgramTiles() {
    try {
      const result = await this.dashaboardService.getProgramTiles();
      this.programTiles.set(Array.isArray(result) ? result : []);
      this.cdr.markForCheck();
    } catch (error) {
      this.programTiles.set([]);
    }
  }

  getListItems(subHeading: string): string[] {
    return subHeading.split(', ');
  }

  // Todo: This action should be emitted to the parent component so that it can handle the routing/modals/whatever 
  nextStep(tile: ProgramTile) {
    this.onTileSelect.emit(tile);
  }
}
